"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Brand = void 0;
const typeorm_1 = require("typeorm");
const oem_1 = require("./oem");
const brand_assets_1 = require("./brand-assets");
const opportunity_option_1 = require("./opportunity-option");
const contact_profile_enum_1 = require("./contact-profile-enum");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const address_1 = require("./address");
const contact_1 = require("./contact");
const base_account_1 = require("./base-account");
let Brand = class Brand extends base_account_1.BaseAccount {
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.PrimaryColumn)({
        type: 'character varying',
        length: 18,
        name: 'id',
        default: () => "public.gid_generate_sfid('001')",
    }),
    __metadata("design:type", String)
], Brand.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 121,
        name: 'name',
    }),
    __metadata("design:type", String)
], Brand.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'email_communication__c',
        nullable: false,
        default: true,
    }),
    __metadata("design:type", Boolean)
], Brand.prototype, "emailCommunication", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 80,
        name: 'emailforinvoices__c',
    }),
    __metadata("design:type", String)
], Brand.prototype, "emailForInvoices", void 0);
__decorate([
    (0, typeorm_1.Column)((type) => address_1.ShippingAddress, {
        prefix: '',
    }),
    __metadata("design:type", address_1.ShippingAddress)
], Brand.prototype, "shippingAddress", void 0);
__decorate([
    (0, typeorm_1.Column)((type) => address_1.BillingAddress, {
        prefix: '',
    }),
    __metadata("design:type", address_1.BillingAddress)
], Brand.prototype, "billingAddress", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: 'createddate',
    }),
    __metadata("design:type", Date)
], Brand.prototype, "createdDate", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: 'lastmodifieddate',
    }),
    __metadata("design:type", Date)
], Brand.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => brand_assets_1.BrandAssets, (brandAssets) => brandAssets.id),
    __metadata("design:type", brand_assets_1.BrandAssets)
], Brand.prototype, "brandAsset", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => oem_1.Oem, (oems) => oems.brands),
    __metadata("design:type", Array)
], Brand.prototype, "oems", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => contact_1.Contact, (contact) => contact.account),
    __metadata("design:type", Array)
], Brand.prototype, "contacts", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_option_1.OpportunityOption, (opOpt) => opOpt.brand),
    __metadata("design:type", Array)
], Brand.prototype, "injectedOpportunityCommunication", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        default: false,
        nullable: false,
    }),
    __metadata("design:type", Boolean)
], Brand.prototype, "showInvoiceMaterialSection", void 0);
Brand = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    data_ui_1.DataUi.Name({
        name: 'Brand',
        nameProperties: ['name'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('account', { schema: 'public', synchronize: false })
], Brand);
exports.Brand = Brand;
//# sourceMappingURL=brand.js.map